export default __webpack_public_path__ + "static/media/star-filled.9046791d.svg";